let Swiper, Navigation, Thumbs;
let productPictureSwiper, moreProductPicturesSwiper;

export default class ProductDetail {
    static inject(swiper, navigation, thumbs) {
        Swiper = swiper;
        Navigation = navigation;
        Thumbs = thumbs;
    }

    constructor() {
        this.fetchDomElements();
        this.registerEventListeners();
        this.createSwipers();
        this.initEasyZoom();
        this.initProductRating();
    }

    fetchDomElements() {
        this.domElements = {
            showAllDetailsBtns: document.querySelectorAll('.showAllDetailsBtn')[0],
            detailsContainer: document.querySelectorAll('.detailsContainer')[0],
            productPictureSliderContainer: document.querySelectorAll('.productPictureSliderContainer')[0],
            moreProductPicturesSliderContainerOuter: document.querySelectorAll('.moreProductPicturesSliderContainerOuter')[0],
            moreProductPicturesSliderContainer: document.querySelectorAll('.moreProductPicturesSliderContainer')[0],
            zoomProductPicturesSliderContainer: document.querySelectorAll('.zoomProductPicturesSliderContainer')[0],
            zoomProductPicturesSliderThumbContainer: document.querySelectorAll('.zoomProductPicturesSliderThumbContainer')[0],
            zoomProductPicturesSliderThumbContainerOuter: document.querySelectorAll('.zoomProductPicturesSliderThumbContainerOuter')[0],
            excerptBtn: document.querySelectorAll('.btn-excerpt')[0],
            excerptModal: document.getElementById('excerptModal'),
            variantDropdowns: document.querySelectorAll('.variantDropdown'),
        };
    }

    registerEventListeners() {
        let $body = $('body');

        if (this.domElements.showAllDetailsBtns) {
            $body.on('click', '.showAllDetailsBtn', (e) => this.onShowAllDetailsBtnClick(e));
        }

        if (this.domElements.excerptBtn) {
            $body.on('click', '.btn-excerpt', (e) => this.handleExcerptClick(e));
        }

        $body.on('click', '#toBasket', (e) => this.handleErrorOnVersionSubmit(e));
        $body.on('click', '.amountToBasketContainer .amountSelectContainer .dropdown-menu-link', (e) => this.handleAmountSelectClick(e));

        $body.on('show.bs.dropdown', '.orderContainer', (e) => this.setDropdownMenuOverflow(e));

        $body.on('click', '#jumpToReview', (e) => {
            e.preventDefault();

            let scrollTop = $('.reviewsContainerWrap').offset().top;

            scrollTop -= 15; // just some space between content element and header/breadcrumb
            scrollTop -= document.getElementById('header').offsetHeight;

            $('html, body').animate({ scrollTop: scrollTop });

            let $reviewForm = $('#review_form');
            if ($reviewForm.length > 0) {
                $reviewForm.collapse('show');
            }
        });

        $body.on('click', '#reviewsLogin', () => {
            $('#loginModal .loginToWriteReview').show();
        });

        $body.on('click', '#showAllReviews', () => {
            this.handleShowAllReviewsButtonClick();
        });

        $body.on('show.bs.modal', '#productDetailZoomModal', () => {
            let productSwiper = document.querySelectorAll('.productPictureSliderContainer')[0].swiper;
            let zoomSwiper = document.querySelectorAll('.zoomProductPicturesSliderContainer')[0].swiper;

            zoomSwiper.slideTo(productSwiper.activeIndex, /* speed */ 0, /* runCallbacks */ false);
        });

        $body.on('hidden.bs.modal', '#loginModal', () => {
            $('#loginModal .loginToWriteReview').hide();
        });

        $(document).ajaxComplete(() => {
            this.fetchDomElements();
            this.createSwipers();
            this.initProductRating();
            this.initEasyZoom();
        });
    }

    handleShowAllReviewsButtonClick() {
        $('.reviewsContainer').children().slideDown(() => {
            document.getElementById('showAllReviews').style.display = 'none';
        });
    }

    initProductRating() {
        let productRating = document.getElementById('productRating');

        let $ratingContainer = $('.productReviewForm .ratingContainer');
        $ratingContainer.on('mouseover', '.lni', (e) => {
            let rateValue = e.target.dataset.rateValue;
            $ratingContainer.removeClass('starCount0 starCount1 starCount2 starCount3 starCount4 starCount5');
            $ratingContainer.addClass('starCount' + rateValue);
        });
        $ratingContainer.on('mouseout', '.lni', (e) => {
            let rateValue = e.target.dataset.rateValue;
            $ratingContainer.removeClass('starCount0 starCount1 starCount2 starCount3 starCount4 starCount5');
            $ratingContainer.addClass('starCount' + productRating.value);
        });
        $ratingContainer.on('click', '.lni', (e) => {
            let rateValue = e.target.dataset.rateValue;
            productRating.value = rateValue;
        });

        let setShowAllReviewsButtonVisibility = () => {
            let $reviews = $('.reviewsContainer .review:not(:visible)');
            if ($reviews.length > 0) {
                document.getElementById('showAllReviews').style.display = 'block';
            } else {
                document.getElementById('showAllReviews').style.display = 'none';
            }
        };
        setShowAllReviewsButtonVisibility();
        let timeoutId = null;
        $(window).on('resize orientationchange', () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => setShowAllReviewsButtonVisibility(), 200);
        });
    }

    setDropdownMenuOverflow(e) {
        let dropdown = e.target;
        let $dropdownMenu = $(dropdown).find('.dropdown-menu');

        let childrenHeight = 0;
        $dropdownMenu.children().each(function() {
            childrenHeight += $(this).outerHeight(true);
        });

        // Right now, the dropdown has 0 height, so this gives us padding +
        // border, which is exactly what we want.
        let dropdownHeight = $dropdownMenu.outerHeight();
        // 190px is the max-height, once the dropdown-menu is open.
        if (dropdownHeight + childrenHeight > 190) {
            $dropdownMenu.addClass('overflowAuto');
        } else {
            $dropdownMenu.removeClass('overflowAuto');
        }
    }

    handleAmountSelectClick(e) {
        e.preventDefault();

        let link = e.target;
        let selectedAmount = link.dataset.selectionId;
        let $amountSelectContainer = $(link).parents('.amountSelectContainer');
        $amountSelectContainer
            .find('input[name="am"]')
            .val(selectedAmount)
        ;
        $amountSelectContainer
            .find('.dropdown-toggle')
            .text(selectedAmount)
        ;
    }

    initEasyZoom() {
        let $easyzoom = $('.easyzoom');
        if ($easyzoom.length > 0) {
            $easyzoom.easyZoom({
                loadingNotice: window.easyZoomLoadingNotice,
                errorNotice:   window.easyZoomErrorNotice,
            });
        }
    }

    handleErrorOnVersionSubmit(e) {
        let variantDropdownsWithNoOptionSelected = document.querySelectorAll('.noOptionChosen');

        if (variantDropdownsWithNoOptionSelected.length > 0) {
            console.log('prevented');
            e.preventDefault();
        }
        this.domElements.variantDropdowns.forEach((element) => {
            if (element.classList.contains('noOptionChosen')) {
                element.classList.add('error');
            }
        });
    }

    handleExcerptClick(e) {
        let windowWidth = window.screen.width;

        if (windowWidth > 991) {
            e.preventDefault();
            $(this.domElements.excerptModal).modal('show');
        }
    }

    onShowAllDetailsBtnClick(e) {
        e.preventDefault();

        this.domElements.detailsContainer.classList.add('show');
        this.domElements.showAllDetailsBtns.classList.add('hidden');
    }

    createSwipers() {
        let productPictureSliderContainer = this.domElements.productPictureSliderContainer;
        let moreProductPicturesSliderContainer = null;
        if (this.domElements.moreProductPicturesSliderContainer) {
            moreProductPicturesSliderContainer = this.domElements.moreProductPicturesSliderContainer;
        }
        let zoomProductPicturesSwiperContainer = this.domElements.zoomProductPicturesSliderContainer;
        let zoomProductPicturesSwiperThumbContainer = this.domElements.zoomProductPicturesSliderThumbContainer;
        let next = null;
        let prev = null;
        if (this.domElements.moreProductPicturesSliderContainerOuter) {
            next = this.domElements.moreProductPicturesSliderContainerOuter.querySelectorAll('.swiper-button-next')[0];
            prev = this.domElements.moreProductPicturesSliderContainerOuter.querySelectorAll('.swiper-button-prev')[0];
        }
        let nextZoom = this.domElements.zoomProductPicturesSliderThumbContainerOuter.querySelectorAll('.swiper-button-next')[0];
        let prevZoom = this.domElements.zoomProductPicturesSliderThumbContainerOuter.querySelectorAll('.swiper-button-prev')[0];

        if (moreProductPicturesSliderContainer) {
            moreProductPicturesSwiper = new Swiper(moreProductPicturesSliderContainer, {
                modules: [Navigation, Thumbs],
                watchOverflow: true,
                // loop: true,
                // touchReleaseOnEdges: true,
                navigation: {
                    nextEl: next,
                    prevEl: prev,
                },
                slidesPerView: 2,
                spaceBetween: 20,
                freeMode: true,
                watchSlidesProgress: true,
                breakpoints: {
                    //.5 ist wichtig um Sliderbug zu verhindern
                    500.5: {
                        slidesPerView: 3,
                    },
                }
            });

            // this.swiper = moreProductPicturesSwiper;
        }

        productPictureSwiper = new Swiper(productPictureSliderContainer, {
            modules: [Navigation, Thumbs],
            watchOverflow: true,
            // loop: true,
            // touchReleaseOnEdges: true,
                // navigation: {
                //     nextEl: next,
                //     prevEl: prev,
                // },
            slidesPerView: 1,
            spaceBetween: 0,
            thumbs: {
                swiper: moreProductPicturesSwiper,
            }
        });

        // this.swiper = productPictureSwiper;

        let zoomProductPicturesSwiperThumb = new Swiper(zoomProductPicturesSwiperThumbContainer, {
            modules: [Navigation, Thumbs],
            watchOverflow: true,
            // loop: true,
            // touchReleaseOnEdges: true,
            navigation: {
                nextEl: nextZoom,
                prevEl: prevZoom,
            },
            slidesPerView: 2,
            spaceBetween: 20,
            freeMode: true,
            watchSlidesProgress: true,
            breakpoints: {
                //.5 ist wichtig um Sliderbug zu verhindern
                767.5: {
                    slidesPerView: 5,
                },
                500.5: {
                    slidesPerView: 3,
                },
            }
        });

        // this.swiper = zoomProductPicturesSwiperThumb;

        let zoomProductPicturesSwiper = new Swiper(zoomProductPicturesSwiperContainer, {
            modules: [Navigation, Thumbs],
            // watchOverflow: true,
            // loop: true,
            // touchReleaseOnEdges: true,
            navigation: {
                nextEl: nextZoom,
                prevEl: prevZoom,
            },
            slidesPerView: 1,
            spaceBetween: 0,
            thumbs: {
                swiper: zoomProductPicturesSwiperThumb,
            },
        });

        // this.swiper = zoomProductPicturesSwiper;
    }
}
